export const SIGN_IN = 'Sign in'

export const SIGN_IN_TITLE = 'Sign In'
